// THIS FILE IS AUTO-GENERATED. DO NOT EDIT.
export const breakpoints = {
  "xs": "25rem",
  "sm": "48rem",
  "md": "62rem",
  "lg": "80rem",
  "xl": "100rem"
};